import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action} from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, {FormBody, FormActions, TextInput, ColorInput} from '../../../Form';

@inject('priorityStore')
@observer
class PriorityEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/priority';
  title = 'Edit Work Order Priority';

  @observable item = {
    caption : '',
    description: '',
    color: ''
  };

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;

  constructor(props) {
    super(props);

    const {params: {id}, priorityStore} = props;

    priorityStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const {params: {id}, priorityStore} = this.props;
    const foundItem = priorityStore.findById(id);
    if (foundItem) {
      this.item = foundItem.asJson;
    }
  }

  handleSave = (e) => {
    e.preventDefault();

    const {priorityStore} = this.props;
    priorityStore.updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  }

  render() {
    const {priorityStore, params: {id}} = this.props;

    if (priorityStore.isLoading) {
      return <Spinner/>;
    }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={priorityStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default PriorityEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Priority/PriorityEdit.js